import { formatCurrency } from '@fourthwall/utils/dist/currency';
export const convertNumberToPrice = (value, currency = 'USD') => ({
    value: formatCurrency(value),
    currency,
});
